import React from 'react'
import { Button } from '@atd/rui-base.mui.button'
import { Dialog } from '@atd/rui-base.mui.dialog'
import { DialogActions } from '@atd/rui-base.mui.dialog-actions'
import { DialogContent } from '@atd/rui-base.mui.dialog-content'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as rxMapActions from './rxMapActions'

import PropTypes from 'prop-types'

import WarningLabel from '../commonComponents/warningLabel'

function mapStateToProps(state, ownProps) {
    return {
        rxMapEditDialog: state.product.rxMapEditDialog,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(rxMapActions, dispatch)
}


class RxMapEdit extends React.Component {
    state = {
        name: 'Select an RxMap for Upload',
        ...this.props.data,
        open: true,
    }
    static propTypes = {
        data: PropTypes.object,
        onRxUpload: PropTypes.func,
    }

    static defaultProps = {
        data: {
            filePath: '',
        },
        onRxUpload: () => {},
        open: true,
    }
    openFileDialog = () => {
        const inputDom = React.findDOMNode(this.refs.FileUpload)
        inputDom.click()
    }
    renderWarning = () => {
        return this.props.rxMapEditDialog.error ? <WarningLabel message={this.props.rxMapEditDialog.error.message} /> : ''
    }
    handleFilePath = (event, value) => {
        if (event.target.files[0]) {
            this.setState({ files: event.target.files, name: event.target.files[0].name })
        }
    }

    handleSubmit = async() => {
        if (this.state.files) {
            const fd = new FormData()
            for (const fl of this.state.files) {
                fd.append('file', fl)
            }
            const rxMaps = await this.props.sendRxMapFile(fd)
            if (!rxMaps) { return }
            if (!rxMaps.error) {
                await this.props.fetchRxMaps()
                if (rxMaps.length) {
                    this.requestClose(() => this.props.onRxUpload(rxMaps[0]))
                }
            }
            this.props.setRxMapEditDialog({ open: (rxMaps.error !== undefined), error: rxMaps})
        }
    }
    requestClose = (onComplete) => {
        this.exitCallback = onComplete
        this.setState({open: false})
    }
    handleCancel = () => {
        this.requestClose(() => this.props.onCancel({ ...this.state }))
    }

    render() {
        const editActions = [
            <Button variant="text"
                key="cancelButton"
                color="primary"
                onClick={this.handleCancel}
                name="cancelButton">Cancel</Button>,
            <Button variant="contained"
                key="saveButton"
                startIcon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_SaveWhite.svg`}/>}
                color="primary"
                onClick={this.handleSubmit}
                name="saveButton">{'Save'}</Button>,
        ]

        return (
            <Dialog
                open={this.state.open}
                onClose={this.handleCancel}
                TransitionProps={{onExited: () => { if (this.exitCallback) this.exitCallback() }}}
                name="rxUpload"
                fullWidth
            >
                <DialogContent>
                    {this.renderWarning()}
                    <Button variant="text" component="label"
                        startIcon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_UploadBlue.svg`}/>}
                        color="primary"
                        name="uploadButton">
                        {this.state.name}
                        <input
                            style={{ display: 'none' }}
                            type="file"
                            accept=".zip"
                            onChange={this.handleFilePath}
                        />
                    </Button>
                </DialogContent>
                <DialogActions>{editActions}</DialogActions>
            </Dialog>

        )
    }
}

// be sure to connect the component to the Redux state so it can use it!
export default connect(mapStateToProps, mapDispatchToProps)(RxMapEdit)
